import { apiClient } from '@/services/api';
import { Observable, from } from 'rxjs';
import { map } from 'rxjs/operators';
import { ENDPOINTS } from '@/settings/api-settings';

export function getGroups(): Observable<any[]> {
  return from(apiClient.get(ENDPOINTS.GROUPS)).pipe(map((r: any) => r.data));
}
export function saveGroup(model: any): Observable<any> {
  return from(apiClient.post(ENDPOINTS.GROUP, model)).pipe(
    map((r: any) => r.data),
  );
}
export function updateOrderGroup(payload: any): Observable<any> {
  return from(apiClient.put(ENDPOINTS.GROUP_ORDER, payload)).pipe(
    map((r: any) => r.data),
  );
}
export function deleteGroup(id: string): Observable<any> {
  return from(apiClient.delete(ENDPOINTS.GROUP, { id })).pipe(
    map((r: any) => r.data),
  );
}
export function getSubgroups(): Observable<any[]> {
  return from(apiClient.get(ENDPOINTS.SUBGROUPS)).pipe(
    map((r: any) => (!!r.data ? r.data : [])),
  );
}
export function getSubgroupsProductOptions(): Observable<any[]> {
  return from(apiClient.get(ENDPOINTS.SUBGROUPS_PRODUCTS_OPTIONS)).pipe(
    map((r: any) => (!!r.data ? r.data : [])),
  );
}
export function saveSubgroup(model: any): Observable<any> {
  return from(apiClient.post(ENDPOINTS.SUBGROUP, model)).pipe(
    map((r: any) => r.data),
  );
}
export function deleteSubgroup(id: string): Observable<any> {
  return from(apiClient.delete(ENDPOINTS.SUBGROUP, { id })).pipe(
    map((r: any) => r.data),
  );
}
